import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

import { Session } from '@services/session';
import { CoachingFeatureFlagService } from '@services/feature-flags/coaching';

import { hasCoachingAccess } from '@lib/coaching/coaching.utils';

@Injectable()
export class CoachingAccessGuard implements CanActivate {
  constructor(
    private router: Router,
    private session: Session,
    private coachingFeatureFlagService: CoachingFeatureFlagService,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const redirectTo: string = route.data?.coachingAccessGuard?.redirectTo;

    const isCoachingAccessAllowed: boolean = hasCoachingAccess(this.session, this.coachingFeatureFlagService);

    if (!isCoachingAccessAllowed) {
      this.router.navigate([redirectTo]);
      return false;
    }

    return true;
  }
}